module.exports = __webpack_public_path__ + "img/woman_facepalming.5a777a70.gif";